export default __webpack_public_path__ + "static/media/1105.f2a650ac.png";